export const NEWS_FEED = "NEWS_FEED";
export const NEWS_FEED_UPDATE = "NEWS_FEED_UPDATE";
export const NEWS_FEED_LIKE = "NEWS_FEED_LIKE";
export const NEWS_FEED_DISLIKE = "NEWS_FEED_DISLIKE";
